/**
 * Created by comoon on 3/3/16.
 */

var $ = require("jquery");

var {copySizing} = require("../util/clazz");

var {ElementConstants} = require("../Constants");

$(function () {

    var topFollow = $(ElementConstants.TOP_NAV_CLASS);

    var win = $(window);

    var tripDays = $(".trip-days");

    var tripDayNavTrigger = tripDays.find(".nav-trigger");

    function repositionTopFollow() {

        var standIn = topFollow.__standIn;

        if (topFollow.hasClass("fixed")) {

            if (win.scrollTop() < standIn.offset().top) {

                standIn.remove();

                topFollow.removeClass("fixed");

                topFollow.__standIn = null;

                delete topFollow.__standIn;
            }
        } else {

            if (win.scrollTop() > topFollow.offset().top) {

                if (!standIn) {

                    topFollow.addClass("fixed");

                    standIn = $("<div></div>");

                    standIn.height(topFollow.height());

                    copySizing(topFollow, standIn);

                    standIn.insertAfter(topFollow);

                    topFollow.__standIn = standIn;
                }
            }
        }
    }


    function toggleDayNavTrigger() {

        var winScrollTop = win.scrollTop();

        var offset = tripDays.offset();

        if (winScrollTop > offset.top && (winScrollTop < (offset.top + tripDays.height()-400))) {

            tripDayNavTrigger.addClass("fixed");

        } else {

            tripDayNavTrigger.removeClass("fixed");
        }
    }

    win.on("scroll", function () {

        repositionTopFollow();

        toggleDayNavTrigger();
    });


    topFollow.on("click", ".nav-item", function () {

        var navItem = $(this);
        $(this).addClass("active").siblings().removeClass("active")

        var target = navItem.data("target");

        var top = $(target).offset().top - topFollow.height();

        win.scrollTop(top);
    });


});


/** WEBPACK FOOTER **
 ** ./script/detail-m/nav-follow.js
 **/